import { Component, EventEmitter, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, SignupPopup } from 'src/environments/environment.interface';

@Component({
  selector: 'df-download-app',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DownloadAppComponent {
  @ViewChild('download', { read: TemplateRef }) download: TemplateRef<any> | undefined;
  slideClass: any = { 'slide-1': true };
  slideNo: number = 0;
  facilityConfig: FacilityConfig;
  signupConfig: SignupPopup;
  
  @Output()
  click: EventEmitter<any> = new EventEmitter<any>();

  downloadSlides: OwlOptions = {
		items: 1,
		nav: true,
		loop: true,
		autoWidth: true,
		responsive: {},
		dots: true,
		autoplay: false,
		smartSpeed: 500,
		animateIn: 'fadeIn',
		animateOut: 'fadeOut',
    autoplayHoverPause: true,
    mouseDrag: true,
    navText: [
      '<img src="/assets/images/svg/arrow_left.svg" alt="" />',
			'<img src="/assets/images/svg/arrow_right.svg" alt="" />'
			// "<i class='fa-solid fa-chevron-left'></i>",
			// "<i class='fa-solid fa-chevron-right'></i>"
		]
	}

  constructor(
    private modalService: NgbModal,
    private _environmentService: EnvironmentService
  ) 
  {
    this.facilityConfig = this._environmentService.getFacilityConfig();
    this.signupConfig = this.facilityConfig.signupPopup;
  }

  public open() {
    this.openModal(this.download);
  }

  public dismiss() {
    this.modalService.dismissAll();
  }

  public openModal(modal: any): void {
    let modalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title', 
      size: 'lg',
      centered: true,
      // fullscreen: window.innerWidth <= 768,
      windowClass: 'margined-modal'
    });
    modalRef.shown.subscribe(() => {
    });
  }

  slideChanged(e: any) {
    this.slideNo = e.startPosition;

    this.slideClass = {};
    this.slideClass[`slide-${this.slideNo}`] = true;
  }

  clicked(e: any) {
    this.click.emit(e); 
  }

  getSlideImage(slideNo: number) {
    if (this.signupConfig.slides[slideNo].sideImage) {
      return this.signupConfig.slides[slideNo].sideImage;
    }
    else {
      return this.signupConfig.slides[0].sideImage;
    }
  }
}
